<template>
    <div>
        <template v-if="!loading">
            <div class="top-right-fixed-button">
                <img @click="refreshReceipt()" src="/img/refresh.webp" width="47px">
            </div>
            <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
                :color="notificationModel.color" />
            <div class="mb-2">
                <div class="card tabs text-center">
                    <div style="overflow-x: scroll;" class="d-flex justify-content-between">
                        <CButton v-for="(tab, index) in tabs" :key="index" @click="selectTab(index)"
                            :class="getTabClass(index)">
                            {{ $t(tab.label) }}
                            <span :class="getTabBadgeClass(index)">{{ getOrderLength(index) }}</span>
                        </CButton>
                    </div>
                    <div class="p-2">
                        <div v-for="(order, index) in getReceiptDoc()" :key="index" :id="getTabSectionId(selectedTab)"
                            v-if="order.receiptItems.length > 0">
                            <div class="order-history-card p-2" @click="handleOrderClick(order.objectId, selectedTab)">
                                <div :class="['order-history-card-header', getOrderStatusColor(order.order)]">
                                    <div class="d-flex justify-content-between w-100">
                                        <span>{{ getStatus(order) }}</span>
                                        {{ showCreatedAtTime(order.created_at) }}
                                    </div>
                                </div>
                                <div class="order-history-card-body">
                                    <div class="d-flex p-2">
                                        <div v-if="order.queue >= 0 && selectedTab !== 0"
                                            class="d-flex align-items-center">
                                            <div>
                                                <h5 class="m-0 p-1"
                                                    style="background-color: var(--bg-color-theme);color: #ffffff;">
                                                    #{{ order.queue }}
                                                </h5>
                                                <h6 class="p-1"
                                                    style="background-color: var(--bg-color-theme);color: #ffffff;opacity: 0.7;">
                                                    {{ $t('queueIndex') }}
                                                </h6>
                                            </div>
                                        </div>
                                        <div class="mt-2" v-else>
                                            <img :src="logo" class="img-fluid" style="border-radius: 500px;"
                                                width="50px" alt="" />
                                        </div>
                                        <div class="pl-3 text-left">
                                            <span>{{ $t('order') }} #{{ order.receiptNumber || order.orderNo
                                            }}</span><br>
                                            <span class="text-left limited-text-one text-description">• {{
                                                order.receiptItems[0].pluName }}</span>
                                            <span class="text-description">
                                                <template v-if="order.receiptItems.length - 1 > 0">
                                                    + {{ order.receiptItems.length - 1 }} more<br>
                                                </template>
                                            </span>
                                            <div class="d-flex">
                                                <span
                                                    class="badge badge-grey p-1 pl-1 pr-2 h6 d-flex align-items-center"
                                                    style="white-space: nowrap;border-radius: 20px;">
                                                    <span class="circle-badge-grey mr-2"><i
                                                            class="fi fi-rr-usd-circle"></i></span>
                                                    {{ summary(order.grandTotal) }} THB</span>
                                                <span
                                                    class="badge badge-grey p-1 pl-1 pr-2 h6 ml-1 d-flex align-items-center"
                                                    style="white-space: nowrap;border-radius: 20px;">
                                                    <span class="circle-badge-grey mr-2"><i
                                                            :class="getTypeOfOrderIcon(order.typeOfOrder)" /></span>
                                                    {{ $t(getTypeOfOrderText(order.typeOfOrder)) }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div v-if="loading">
            <div class="c-app" style="background-color: #ffffff">
                <div class="c-wrapper">
                    <div class="c-body">
                        <div class="lds-ripple">
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="showEmptyData() && !loading">
            <div style="height: 70vh;" class="d-flex justify-content-center align-items-center">
                <div class="text-center p-4">
                    <img width="50%" src="/img/receipt_empty.png">
                    <h4 class="mt-5">{{ $t('noTransaction') }}</h4>
                    <span class="text-description ">{{ $t('letOrder') }}</span><br>
                    <div class="fixed-bottom p-3">
                        <CButton @click="$router.push('/delivery/menulists')" block class="btn-color-theme">
                            {{ $t('backToMenu') }}</CButton>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AppPushNotification from '@/components/AppPushNotification.vue'
import util from '@/util/util'
import '@/util/menu.css'
import '@/util/tabs.css'
import '@/util/delivery.css'
import pos from '@/services/pos'
import moment from 'moment'

export default {
    components: {
        AppPushNotification
    },
    data() {
        return {
            unPaidOrder: [],
            pendingOrder: [],
            successOrder: [],
            cancelOrder: [],
            receipt: {
                items: [],
                total: '',
                id: '',
                timeStamp: '',
                note: '',
                delivery: { distance: 0, deliveryAddress: { name: 'Liberty ชั้น 3 ทองหล่อ บริษัทสีลมเทคโนโลยี' }, latlng: {} },
            },
            receiptStatus: 'จัดส่งสำเร็จ',
            loading: true,
            selectedTab: 0,
            tabs: [
                { label: 'toPay' },
                { label: 'onPending' },
                { label: 'OnSuccessOrder' },
                { label: 'cancel' },
            ],
            canRefresh: true,
            notificationModel: {
                color: '',
                title: '',
                text: '',
            },
        }
    },

    computed: {
        ...mapGetters(['shopLineOA']),
        uid() {
            return `${localStorage.getItem('uid')}`
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        shopName() {
            if (this.shop) {
                return this.shop.shopName
            } else {
                return ''
            }
        },
        source() {
            return this.$route.query.source || ''
        },
        logo() {
            const shop = this.shop || {}
            if (shop.remoteImagePath != undefined) {
                return shop.remoteImagePath
            } else {
                return ' https://cdn-icons-png.flaticon.com/512/9718/9718703.png '
            }
        },
    },
    created() {
        this.selectedTab = parseInt(sessionStorage.getItem('_history_tab')) || 0
        this.getReceipt()
        localStorage.removeItem('receiptObjectId')
    },
    methods: {
        ...util,
        getReceiptDoc() {
            switch (this.selectedTab) {
                case 0:
                    return this.unPaidOrder
                case 1:
                    return this.pendingOrder
                case 2:
                    return this.successOrder
                case 3:
                    return this.cancelOrder
                default: return {}
            }
        },
        getTabSectionId(tabIndex) {
            switch (tabIndex) {
                case 0: return 'unpaid-section';
                case 1: return 'pending-section';
                case 2: return 'completed-section';
                default: return '';
            }
        },
        handleOrderClick(objectId, tabIndex) {
            if (tabIndex === 1 || tabIndex === 2 || tabIndex === 3) {
                this.openTracking(objectId);
            } else {
                this.$router.push(`/delivery/order-details?objectId=${objectId}`);
            }
        },
        setReceiptStatus() {
            this.receiptStatus = this.receiptStatus == 'จัดส่งสำเร็จ' ? 'ยกเลิกออเดอร์' : 'จัดส่งสำเร็จ';
        },
        summary(amount) {
            return util.convertCurrency(amount)
        },
        getStatus(order) {
            if (this.selectedTab == 0) {
                return this.$t('waitForPaymentDelivery')
            } else {
                switch (order.order.orderStatus) {
                    case "NEW":
                        return this.$t('newOrderIn')
                    case "ACCEPT":
                        return this.$t('shopReceivedOrder')
                    case "PREPARE":
                        return this.$t('OnPreparing')
                    case "CANCEL":
                        return this.$t('cancel')
                    case "REJECT":
                        return this.$t('cancel')
                    case "READY_TO_SHIP":
                        if (order.typeOfOrder == 4) {
                            return this.$t('readyToShip')
                        } else if (order.typeOfOrder == 3) {
                            return this.$t('readyForPcikup')
                        } else {
                            return this.$t('readyToServeDelivery')
                        }
                    case "SHIPPING":
                        if (order.typeOfOrder == 4) {
                            return this.$t('shippingDelivery')
                        } else {
                            return this.$t('readyForPcikup')
                        }
                    case "FINISH":
                        return this.$t('finish')
                    default:
                        return order.order.orderStatus
                }
            }
        },
        getOrderStatusColor(order) {
            if (this.selectedTab == 0) {
                return 'badge-info h6'
            } else {
                switch (order.orderStatus) {
                    case "NEW":
                        return 'badge-info h6'
                    case "ACCEPT":
                        return 'badge-accept h6'
                    case "PREPARE":
                        return 'badge-warning h6 text-white'
                    case "CANCEL":
                        return 'badge-danger h6'
                    case "REJECT":
                        return 'badge-danger h6'
                    case "READY_TO_SHIP":
                        return 'badge-served h6'
                    case "SHIPPING":
                        return 'badge-served h6'
                    case "FINISH":
                        return 'badge-served h6'
                    default:
                        return order.orderStatus
                }
            }
        },
        openTracking(id) {
            this.$router.push('/delivery/tracking?objectId=' + id)
        },
        getTabClass(i) {
            return i === this.selectedTab ? 'tab-status-active d-flex align-items-center' : 'tab-status d-flex align-items-center';
        },
        getTabBadgeClass(i) {
            return i === this.selectedTab ? 'circle-badge-active ml-2' : 'circle-badge ml-2';
        },
        selectTab(i) {
            sessionStorage.setItem('_history_tab', i)
            this.selectedTab = i
        },
        showEmptyData() {
            const orders = [this.unPaidOrder, this.pendingOrder, this.successOrder, this.cancelOrder];
            return orders[this.selectedTab]?.length === 0;
        },
        async getReceipt() {
            const uid = localStorage.getItem('uid');
            const shopObjectId = localStorage.getItem('shopObjectId');

            if (!uid || !shopObjectId) return;

            this.loading = true;

            try {
                const res = await pos({
                    url: `/api/v1.3/${uid}/profile/order/get`,
                    method: 'get',
                    params: { shopObjectId }
                });

                if (res.data.error.code === 0) {
                    const data = res.data.data || {};

                    this.unPaidOrder = data.unPaidOrder || [];
                    this.pendingOrder = data.pendingOrder || [];
                    this.successOrder = data.successOrder || [];
                    this.cancelOrder = data.cancelOrder || [];

                } else if (res.data.error.code === 402) {
                    this.renewToken();
                } else if (res.data.error.code === 4000) {
                    this.logOut();
                }
            } catch (error) {
                console.error("getReceipt error:", error);
            } finally {
                this.loading = false;
            }
        },
        async renewToken() {
            try {
                if (localStorage.getItem('refreshToken')) {
                    const refreshToken = localStorage.getItem('refreshToken')

                    let res = {}
                    res = await pos({
                        url: `/auth/v1.0/renewtoken/otp`,
                        method: 'post',
                        data: {
                            "refreshToken": refreshToken
                        }
                    });
                    if (res.data?.error?.code == 0) {
                        localStorage.setItem('token', res.data?.data?.token)
                        window.location.reload()
                    } else {
                        this.logOut()
                    }
                }
            } catch (error) {
                console.error(error);
            }
        },
        logOut() {
            const uid = localStorage.getItem('uid')
            const shopObjectId = localStorage.getItem('shopObjectId')
            sessionStorage.clear()
            localStorage.clear()
            localStorage.setItem('uid', uid)
            localStorage.setItem('shopObjectId', shopObjectId)
            this.$router.push('/delivery/home')
        },
        showCreatedAtTime(time) {
            moment.locale(this.$i18n.locale || 'en')
            const timeAgo = time ? moment(time).fromNow() : '-'
            return `${this.$i18n.t('orderedAt')} ${timeAgo}`
        },
        getTypeOfOrderText(type) {
            switch (type) {
                case 1:
                    return 'dine-in'
                case 3:
                    return 'pickupType'

                default:
                    return type;
            }
        },
        getTypeOfOrderIcon(type) {
            switch (type) {
                case 1:
                    return 'fi fi-rr-utensils'
                case 3:
                    return 'fi fi-rr-shopping-bag'

                default:
                    return type;
            }
        },
        async refreshReceipt() {
            if (this.canRefresh) {
                await this.getReceipt()
                this.showNotification(this.$t('updatedStaus'), '', 'success')
                this.canRefresh = false
                setTimeout(() => {
                    this.canRefresh = true
                }, 5000);
            } else {
                this.showNotification(this.$t('updatedStaus'), '', 'success')
            }
        },
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text,
            }
            this.$refs.notification.pushNotification();
        },
        getOrderLength(index) {
            switch (index) {
                case 0:
                    return this.unPaidOrder?.length || 0;
                case 1:
                    return this.pendingOrder?.length || 0;
                case 2:
                    return this.successOrder?.length || 0;
                case 3:
                    return this.cancelOrder?.length || 0;
                default:
                    return 0;
            }
        }

    },
}
</script>
<style>
.tab-status {
    white-space: nowrap;
    background-color: #eeeeee;
    color: var(--dark);
    font-size: large;
    border-radius: 40px;
    margin: 1cap;
    padding-left: 3cap;
    padding-right: 1cap;
    width: 100%
}

.tab-status:hover {
    color: var(--dark);
}

.tab-status-active,
.tab-status-active:hover {
    white-space: nowrap;
    background-color: var(--bg-color-theme);
    color: white;
    font-size: large;
    border-radius: 40px;
    margin: 1cap;
    padding-left: 3cap;
    padding-right: 1cap;
    width: 100%
}
</style>
